import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import UserStore from '../stores/UserStore'
import Layout from './Layout'

const PrivateRoute = ({ component: Component, ...rest }) => {
  return(
  <Route {...rest} render={(props) => (
    UserStore.isAuthenticated === true
      ? <Layout showPaper={props.location.pathname!== '/configuracion'}>
         <Component {...props} title={rest.title} menu={rest.menu} />
        </Layout>
      : <Redirect to={{
        pathname: '/login',
        state: { from: props.location }
      }} />
  )} />)
}


export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js